<template>
    <div class="content">
        <div class="hw-content">
            <div class="title mb20">对账资料汇总申请详情</div>
            <div>
                <el-descriptions title="" :column="1" border size="medium" labelClassName="application-label">
                    <el-descriptions-item label="客户名称">
                        <div class="rows">{{ result.Apply_CustomerName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户编码">
                        <div class="rows">{{ result.Apply_CustomerCode }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="订单号">
                        <div class="rows">{{ result.Apply_OrderNo }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="工程名称">
                        <div class="rows">{{ result.Apply_ProjectName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="业务员">
                        <div class="rows">{{ result.Apply_OfficeManCode }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="创建人">
                        <div class="rows">{{ result.Apply_UserName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="对账区间">
                        <div class="rows">{{ result.Apply_Start }} - {{ result.Apply_End }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="对账资料附件">
                        <div class="rows">
                            <el-link v-if="result.Apply_Attachment" @click="goDownload(result.Apply_Attachment)">下载附件</el-link>
                            <span v-else>无</span>
                            <span class="tiptxt">支持附件来自于公司信息化系统记录，可能不完整，建议检查后使用。</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="申请时间">
                        <div class="rows">{{ elformatDate(result.Apply_AddTime) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="申请状态">
                        <div class="rows" :class="judgeColor(result.Apply_Status == 1 ? '已处理' : '未处理')">{{ result.Apply_Status == 1 ? '已处理' : '未处理' }}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="mt20" style="text-align: right">
                <el-button type="" size="medium" @click="$router.go(-1)">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'applicationDetail',
    data() {
        return {
            result: {},
            id: ''
        };
    },
    created() {
        const query = this.$route.query;
        this.id = query.id;
        if (this.id) {
            this.id = query.id;
            this.getData(this.id);
        }
    },
    methods: {
        getData(e) {
            this.$newsApi.GetCustomerReconciliationApplyByID({ ApplyID: e }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.result = res.data.data;
                }
            });
        },
        goDownload(e) {
            window.open(this.$ossUrl + e, '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}
.tiptxt {
    color: red;
    font-weight: 700;
    margin-left: 20px;
}
</style>
<style  lang="scss">
.application-label {
    text-align: right !important;
    width: 170px;
    color: #333;
    background-color: #f5f7fa !important;
}
</style>